

import seoTags from "@/mixins/seoTags";
import {mapMutations} from "vuex";
import validateCategory from "~/mixins/validateCategory";

export default {
	mixins: [seoTags,validateCategory],
	// validate(ctx) {
	// 	return ctx.params.category === 'cars';
	// },
	mounted() {
		// setTimeout(function () {window.scrollTo(0, -100);}, 1);
		// if(!this.$device.isMobile){
		// 	setTimeout(function () {window.scrollTo(0, 300);}, 2);
		// }

		this.setBackButton(this.currentBackButton)
	},
	beforeDestroy() {
		this.setBackButton({})
	},
	methods: {
		...mapMutations({
			setBackButton: 'header/header/SET_BACK_BUTTON'
		})
	},
	computed: {
		currentBackButton() {
			return {
				title: 'Все модели ' + this.crumbs[2].title,
				link: this.crumbs[2].link
			}
		},
	},
}
